import React from "react";
import { SubsectionWithFields } from "./subsection/fields";
import { SearchCommonField } from "../inputs/common-field";
import { SubsectionWithCheckboxes } from "./subsection/checkboxes";

export const OtherSection = () => {
    return (
        <>
            <SubsectionWithCheckboxes
                label={"What should be the place known for?"}
            >
                <SearchCommonField name="scenes.yoga" />
                <SearchCommonField name="scenes.streetFood" />
                <SearchCommonField name="scenes.fineDining" />
                <SearchCommonField name="scenes.digitalNomads" />
                <SearchCommonField name="scenes.latinoDance" />
                <SearchCommonField name="scenes.electronicDanceMusic" />
                <SearchCommonField
                    name="scenes.traditionalDancesAndArts"
                    className="col-span-2"
                />
            </SubsectionWithCheckboxes>
            <SubsectionWithFields>
                <SearchCommonField name="distance" />
                <SearchCommonField name="other.season" />
                <SearchCommonField name="other.boat" />
                <SearchCommonField name="other.island" />
                <SearchCommonField name="other.airportDistance" />
                <SearchCommonField name="other.vaccinationRequirements" />
                <SearchCommonField name="other.visa" />
                <SearchCommonField name="other.visaOrigin" />
                <SearchCommonField name="other.englishKnowledge" />
            </SubsectionWithFields>
        </>
    );
};
